class ProgressBar extends HTMLElement {
    constructor() {
      super();
      this.progress = parseInt(this.dataset.value);
    }

    connectedCallback() {
      // Get the new progress value from inline style
      const newProgressMatch = this.getAttribute('style')?.match(/--progress:\s*([\d.]+)%/);
      const newProgress = newProgressMatch ? newProgressMatch[1] + '%' : null;
      
      if (!newProgress) return;
      
      // Get stored old progress from sessionStorage
      const oldProgress = sessionStorage.getItem('progress-bar-value');
      const hasPlayedInitialAnimation = sessionStorage.getItem('progress-bar-initial-played');
      
      if (!hasPlayedInitialAnimation) {
        // First time, animate from 0 to current value
        this.style.setProperty('--progress-from', '0%');
        this.style.setProperty('--progress', '0%');
        
        // Delay to ensure drawer is visible
        setTimeout(() => {
          this.style.setProperty('--progress', newProgress);
          sessionStorage.setItem('progress-bar-initial-played', 'true');
        }, 750);
      } else if (oldProgress && oldProgress !== newProgress) {
        // Cart update, transition from old to new value
        this.style.setProperty('--progress-from', oldProgress);
        this.style.setProperty('--progress', oldProgress);
        
        // Transition to new value after delay
        setTimeout(() => {
          this.style.setProperty('--progress-from', oldProgress);
          this.style.setProperty('--progress', newProgress);
        }, 750);
      } else {
        // Reopening cart without changes
        this.style.setProperty('--progress-from', newProgress);
        this.style.setProperty('--progress', newProgress);
      }
      
      // Store the new progress value for next update
      sessionStorage.setItem('progress-bar-value', newProgress);
    }
  }
  
  customElements.define('progress-bar', ProgressBar);
